import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import { grey } from "@mui/material/colors";

const cards = [
	{
		name: "YTD REV",
		key: "YTD REV",
		types: [
			{
				name: "CR-RSV",
				key: "",
				value: 1000,
			},
			{
				name: "LS-QTY",
				key: "",
				value: 31,
			},
		],
	},
	{
		name: "INVENTORY",
		key: "INVENTORY",
		types: [
			{
				name: "CR-MRP",
				key: "",
				value: 100,
			},
			{
				name: "CR-COGS",
				key: "",
				value: 18,
			},
			{
				name: "LS-QTY",
				key: "",
				value: 3.27,
			},
		],
	},
	{
		name: "EFFICENCY",
		key: "EFFICENCY",
		types: [
			{
				name: "ASP",
				key: "",
				value: 2250,
			},
			{
				name: "AOV",
				key: "",
				value: 3000,
			},
			{
				name: "GP",
				key: "",
				value: "71%",
			},
			{
				name: "DISC",
				key: "",
				value: "20%",
			},
			{
				name: "MULTIES",
				key: "",
				value: "61%",
			},
			{
				name: "RTV",
				key: "",
				value: "31%",
			},
		],
	},
	{
		name: "COMPARISON",
		key: "COMPARISON",
		types: [
			{
				name: "REV",
				key: "",
				value: "18%",
			},
			{
				name: "QTY",
				key: "",
				value: "20%",
			},
			{
				name: "ASP",
				key: "",
				value: "22%",
			},
			{
				name: "DISC",
				key: "",
				value: "5%",
			},
			{
				name: "GP",
				key: "",
				value: "10%",
			},
			{
				name: "AOV",
				key: "",
				value: "16%",
			},
		],
	},
	{
		name: "MARKETING",
		key: "MARKETING",
		types: [
			{
				name: "CR-FB SPEND",
				key: "",
				value: 100,
			},
			{
				name: "CR GGL SPEND",
				key: "",
				value: 18,
			},
			{
				name: "CR-MYNTRA",
				key: "",
				value: 3.27,
			},
			{
				name: "ROAS D2C",
				key: "",
				value: 3.27,
			},
			{
				name: "ROAS MYNTRA",
				key: "",
				value: 3.27,
			},
		],
	},
];

const Home = () => {
	return (
		<Stack maxWidth="90vw" margin="auto" alignItems="center" spacing={2}>
			<Box width="100%">
				<Divider sx={{ mb: 2 }} orientation="horzontal" />
			</Box>
			<Box width="100%" height="100%" mt={3} display="flex" justifyContent="space-around">
				<img width="90px" src="/images/thor_logo.jpeg" />
			</Box>
			<Box width="100%">
				<Divider sx={{ mt: 2 }} orientation="horzontal" />
			</Box>
			{/* <Box width="100%" display="flex" columnGap="2%" flexWrap="wrap" justifyContent="space-around">
				{cards?.map((row) => {
					return (
						<Card sx={{ width: "15%" }}>
							<CardContent>
								<Typography
									variant="h6"
									textAlign="center"
									gutterBottom
									sx={{ color: "text.secondary", fontSize: 14 }}>
									{row?.name}
								</Typography>
								<Divider />

								{row?.types?.map((row) => {
									return (
										<Box display="flex" justifyContent="center" alignItems="center" mt={1} columnGap={1}>
											<Typography
												variant="h6"
												gutterBottom
												sx={{ color: "text.secondary", fontSize: 16, p: 0, m: 0 }}>
												{row?.value} &#x2B06;
											</Typography>
											<Typography
												variant="h6"
												gutterBottom
												alignSelf="flex-end"
												sx={{ color: "text.secondary", fontSize: 10, p: 0, m: 0 }}>
												{row?.name}
											</Typography>
										</Box>
									);
								})}
							</CardContent>
						</Card>
					);
				})}
			</Box> */}

			<Stack width="90vw" margin="auto" height="80vh" alignItems="center" spacing={2} sx={{ backgroundColor: grey[200] }}>
				<iframe
					width="100%"
					view
					height="100%"
					src="https://lookerstudio.google.com/embed/reporting/73c6b3b5-4d02-454a-98e7-2aa67b9caa8b/page/cnFOF"
					frameborder="0"
					style={{ border: 0 }}
					allowfullscreen
					sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe>
			</Stack>
		</Stack>
	);
};

export default Home;